import { render, staticRenderFns } from "./ScopeFilters.vue?vue&type=template&id=372c1961&scoped=true"
import script from "./ScopeFilters.vue?vue&type=script&lang=js"
export * from "./ScopeFilters.vue?vue&type=script&lang=js"
import style0 from "./ScopeFilters.vue?vue&type=style&index=0&id=372c1961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c1961",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
